// project import
import veille from "./veille";
// import home from './home';
import formation from "./formation";
import modules from "./modules";
import masterclass from "./masterclass";
import hub from "./hub";
import agenda from "./agenda";
import medicaments from "./medicament";
import pathologies from "./pathologies";
import learning from "./learning";
import favorites from "./favorites";
// import profile from './profile';
import newsletter from "./newsletter";
import avis from "./avis";
import experts from "./experts";
import library from "./library";

import Support from "./help";
import { isBrandFeatureEnabled } from "brand/features";

// ==============================|| MENU ITEMS ||============================== //

const items = [
  veille,
  avis,
  experts,
  isBrandFeatureEnabled("medications") ? medicaments : null,
  isBrandFeatureEnabled("pathologies") ? pathologies : null,
  formation,
  modules,
  masterclass,
  hub,
  agenda,
  learning,
  favorites,
  newsletter,
  library,
  Support,
].filter(Boolean);

const menuItems = {
  items,
};

export default menuItems;
